import React from 'react';
import { Modal, Box, Typography } from '@mui/material';
import kocLogo from '../../assets/koc-logo-footer.png';
import kocAilemlogo from '../../assets/images/koc-ailem-logo.png';
import warningIco from '../../assets/images/join-form/istockphoto-865698308-70x70.png'


interface SuccessPageProps {
  open: boolean;
  handleClose: () => void;
  message: string;
}

const WarningModal: React.FC<SuccessPageProps> = ({ open, handleClose, message }) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    bgcolor: 'background.paper',
    borderRadius: '8px',
    boxShadow: 24,
    p: 4,
    textAlign: 'center',
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>

        <div style={{ textAlign: 'center' }}>
          <img src={warningIco} alt="KoçAilem hata logo" style={{ maxWidth: '100%', margin: '0 auto' }} />
        </div>
        <Typography sx={{ mt: 2 }}>
          {message}
        </Typography>
      </Box>
    </Modal>
  );
};

export default WarningModal;
